var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full bg-white overflow-hidden"},[_c('NavHeader',{staticClass:"flex-none"}),_c('div',{staticClass:"flex-grow overflow-hidden w-full h-full"},[_c('router-view',{attrs:{"id":"routerView"}}),_c('NavFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }